import {axiosRequest} from "./apiBase";
import {EnvironmentConfig} from "../common/configs/environment.config";
import {AuthToken} from "../common/types/authToken.type";
import {SSOAutofillDetails} from "../common/types/ssoAutofillDetails.type";

export const loginWithEmailPassword = (userName: string, password: string): Promise<AuthToken> => {

    const authDetails = {
        grant_type: "password",
        client_id: EnvironmentConfig.PasswordAuthClientId,
        client_secret: EnvironmentConfig.PasswordAuthClientSecret,
        userName: userName,
        password: password
    };

    return axiosRequest(
        "POST",
        `connect/token`,
        authDetails,
        true
    )
}

export const ssoLogin = (state: string, nonce: string) : Promise<AuthToken> => {
    return axiosRequest(
        "GET",
        `auth/token?state=${state}&nonce=${nonce}`
    );
}

export const getSignupAutofillDetailsForSSO = (state: string, nonce: string): Promise<SSOAutofillDetails> => {
    
    return axiosRequest(
        "GET",
        `auth/getSignupAutofillDetailsForSSO?state=${state}&nonce=${nonce}`,
    );
};